import { toast } from 'react-toastify';

export const getErrorMessage = error => {
  if (!error.response) {
    return 'Network error. Please check your connection and try again.';
  }

  const { status, data } = error.response;

  if (data?.error === 'INSUFFICIENT_PERMISSIONS') {
    const roleContext = data.userRole ? ` (Current role: ${data.userRole})` : '';
    const accessContext =
      data.accessLevel === 'self' ? ' You can only access your own information.' : '';
    return `${data.message || 'Access denied.'}${accessContext}${roleContext}`;
  }

  if (data?.message) {
    return data.message;
  }

  if (data?.error) {
    return data.error;
  }

  if (data?.errors && Array.isArray(data.errors)) {
    return data.errors.map(err => err.msg || err.message).join(', ');
  }

  switch (status) {
    case 400:
      return 'Invalid request. Please check your input and try again.';
    case 401:
      return 'You are not authorized. Please log in and try again.';
    case 403:
      return 'Access denied. You do not have permission to perform this action.';
    case 404:
      return 'The requested resource was not found.';
    case 409:
      return 'This action conflicts with existing data.';
    case 422:
      return 'The provided data is invalid. Please check and try again.';
    case 423:
      return 'Account is temporarily locked due to too many failed login attempts. Please try again later 10mins.';
    case 429:
      return 'Too many requests. Please wait a moment and try again.';
    case 500:
      return 'Server error. Please try again later.';
    case 502:
      return 'Service temporarily unavailable. Please try again later.';
    case 503:
      return 'Service unavailable. Please try again later.';
    default:
      return `An error occurred (${status}). Please try again.`;
  }
};

export const handleApiError = (error, defaultMessage = 'An error occurred', logError = true) => {
  if (logError) {
    console.error('API Error:', error);
  }

  const errorMessage = getErrorMessage(error);
  toast.error(errorMessage || defaultMessage);

  return errorMessage;
};

export const handleApiSuccess = message => {
  toast.success(message);
};

export const handleValidationErrors = errors => {
  if (!errors || typeof errors !== 'object') {
    return 'Validation failed';
  }

  const errorMessages = Object.values(errors)
    .flat()
    .filter(Boolean)
    .map(error => error.message || error)
    .join(', ');

  if (errorMessages) {
    toast.error(errorMessages);
    return errorMessages;
  }

  return 'Please check your input and try again';
};

export const showLoadingToast = (message = 'Processing...') => {
  return toast.loading(message);
};

export const updateToastSuccess = (toastId, message) => {
  toast.update(toastId, {
    render: message,
    type: 'success',
    isLoading: false,
    autoClose: 3000,
  });
};

export const updateToastError = (toastId, message) => {
  toast.update(toastId, {
    render: message,
    type: 'error',
    isLoading: false,
    autoClose: 5000,
  });
};
